import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PreviousRouteService } from 'src/app/shared/previous-route.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-exit',
  templateUrl: './edit-exit.component.html',
  styleUrls: ['./edit-exit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditExitComponent implements OnInit {
  url = '';

  constructor(
    private previousRouteService: PreviousRouteService,
    private router: Router
  ) { }

  ngOnInit() {
    this.url = this.previousRouteService.getPreviousUrl();
  }

  exit() {
    switch (true) {
      case this.url.startsWith('/explore'):
      case this.url.startsWith('/dashboard'):
      case this.url.startsWith('/view'):
        this.router.navigateByUrl(this.url);
        break;
      default:
        this.router.navigateByUrl('/dashboard');
        break;
    }
  }
}
